import React, { useState, useEffect } from 'react';
import { appliedRuleIcon, restartIcon } from "../../assets/images";
import { CalculationUtils, formatter, validate } from "../../utility";
import { Button } from 'react-bootstrap';
import { CustomDateInput } from "../Helper/InputBase";
import appConstants from '../../config/app_config';
import moment from 'moment';
import GeneralUtils from '../../utility/GeneralUtils';

const MAX_PORTION_PERCENTAGE = 0.03;
const DROPDOWN_NO_VALUE = '0';
const DROPDOWN_YES_VALUE = '1';

const RICalcStepTwo = (props) => {
  
  const {
    calc_p1RemainingEligibleAmount
  } = props?.phaseOneData

  const {
    calc_p2EarliestServiceDate,
    calc_p2MaxRentIncreaseDate,
    calc_p2MinRentIncreaseDate,
    calc_p2IsServiceTimeAvailable,
    stepTwoSubmitted,
    isRentIncreaseAfterPhase2,
    rentIncreaseDateAfterPhase2,
  } = props?.phaseTwoData;

  const {
    phase1RentAmountUsed
  } = props?.phaseOneData;
  
  const [stepTwoData, setStepTwoData] = useState({
    phase2RentIncreaseDate: props?.phaseTwoData?.phase2RentIncreaseDate || '',
    errors: {}
  });

  useEffect(() => {
    if (!calc_p2IsServiceTimeAvailable || isRentIncreaseAfterPhase2) {
      const stepTwoVars = setStepTwoVars();
      props?.setPhaseTwoData({...props?.phaseTwoData, ...stepTwoData, ...stepTwoVars, ...{  stepTwoSubmitted: true }});
    }
  },[calc_p2IsServiceTimeAvailable])

  const handleDateChange = (value, event) => {
    const { name } = event;
    setStepTwoData({...stepTwoData, [name]: value, errors: { ...stepTwoData?.errors, [name]: '' }})
  }

  const setStepTwoVars = () => {
    const calc_p2RentIncreaseDate = 
      calc_p2IsServiceTimeAvailable && !isRentIncreaseAfterPhase2 ? phase2RentIncreaseDate :
      calc_p2IsServiceTimeAvailable && isRentIncreaseAfterPhase2 ? rentIncreaseDateAfterPhase2 :
      calc_p2MaxRentIncreaseDate
    
    const calc_p2CPIYear = moment(calc_p2RentIncreaseDate).year();
    const calcCPIValue = CalculationUtils.getCpiForYear(props?.cpiConfig, calc_p2CPIYear)?.value || null;
    const calc_p2CPIValue = calcCPIValue ? (calcCPIValue / 100).toFixed(3) : 0;
    const calc_nextCPIUpdateDate = moment(`Sep 15, ${calc_p2CPIYear}`).subtract(1, 'year');
    const calc_p2MaxCPIAmountStandardRentIncrease = formatter.toFixedNumber(Number(phase1RentAmountUsed) * Number(calc_p2CPIValue), 3);
    const calc_p2MaxRentAmountStandardRentIncrease = formatter.toFixedNumber(Number(phase1RentAmountUsed) + Number(calc_p2MaxCPIAmountStandardRentIncrease), 2);
    const p2MaxEligibleAmount = formatter.toFixedNumber((Number(calc_p2MaxRentAmountStandardRentIncrease) * MAX_PORTION_PERCENTAGE), 3);
    const calc_p2MaxEligibleAmount = Math.min(calc_p1RemainingEligibleAmount, p2MaxEligibleAmount);
    const calc_p2AppliedEligibleAmount = Number(calc_p2MaxEligibleAmount) <= Number(calc_p1RemainingEligibleAmount) ? calc_p2MaxEligibleAmount : calc_p1RemainingEligibleAmount;
    const calc_p2MaxAdditionalRentIncrease = formatter.toFixedNumber(Number(calc_p2MaxRentAmountStandardRentIncrease) + Number(calc_p2AppliedEligibleAmount), 2);
    const calc_p2RemainingEligibleAmount = calc_p2MaxEligibleAmount > 0 ? calc_p1RemainingEligibleAmount - calc_p2MaxEligibleAmount : 0;

    const p2StepTwoData = {
      calc_p2RentIncreaseDate,
      calc_p2CPIYear,
      calc_p2CPIValue,
      calc_nextCPIUpdateDate,
      calc_p2MaxCPIAmountStandardRentIncrease,
      calc_p2MaxRentAmountStandardRentIncrease,
      calc_p2MaxEligibleAmount,
      calc_p2AppliedEligibleAmount,
      calc_p2MaxAdditionalRentIncrease,
      calc_p2RemainingEligibleAmount,
      calcCPIValue
    }

    GeneralUtils.log('----- PRINTING ALL PHASE 2 - STEP 2 VARIABLES -----', 'success');
    GeneralUtils.log(`
    calc_p2RentIncreaseDate: ${calc_p2RentIncreaseDate}\n
    calc_p2CPIYear: ${calc_p2CPIYear}\n
    calc_p2CPIValue: ${calc_p2CPIValue}\n
    calc_nextCPIUpdateDate: ${formatter.toDateDisplay(calc_nextCPIUpdateDate)}\n
    calc_p2MaxCPIAmountStandardRentIncrease: ${calc_p2MaxCPIAmountStandardRentIncrease}\n
    calc_p2MaxRentAmountStandardRentIncrease: ${calc_p2MaxRentAmountStandardRentIncrease}\n
    calc_p2MaxEligibleAmount: ${calc_p2MaxEligibleAmount}\n
    calc_p2AppliedEligibleAmount: ${calc_p2AppliedEligibleAmount}\n
    calc_p2MaxAdditionalRentIncrease: ${calc_p2MaxAdditionalRentIncrease}\n
    calc_p2RemainingEligibleAmount: ${calc_p2RemainingEligibleAmount}
    `, 'info')

    return p2StepTwoData;
  }

  const submitStepTwo = () => {
    const validations = [
      {
        phase2RentIncreaseDate,
        validationRules: [{ isRequired: true, errorMsg: 'Date is required' }],
      },
    ]
    
    const validationErrors = validate(validations);
    if (Object.keys(validationErrors).length) {
      setStepTwoData({...stepTwoData, errors: validationErrors });
    } else {
      const stepTwoVars = setStepTwoVars();
      props?.setPhaseTwoData({...props?.phaseTwoData, ...stepTwoData, ...stepTwoVars, ...{  stepTwoSubmitted: true }});
    }
  }

  const modifyClicked = () => {
    props?.setPhaseTwoData({...props?.phaseTwoData, ...{  stepTwoSubmitted: false, stepThreeSubmitted: false }});
  }

  const { phase2RentIncreaseDate, errors } = stepTwoData;

  return (
    <div className="ric__step-two">
      <p className="ric__rule">
        <img className="w1-step-three__rule__icon" src={appliedRuleIcon} alt='' />
        <span>
          <b>Applied Rule</b>: The second additional rent increase (phase 2) can only be imposed at least 12 months after the effective date of the most recent rent increase, and a notice of rent increase must be served at least three full months before the effective date of the rent increase.
          <span className="w1-step-three__rule--success">&nbsp;Based on today's date and the information you provided, the earliest allowed effective date for the phase 2 rent increase would be&nbsp;<b>{formatter.toDateDisplay(calc_p2MinRentIncreaseDate, { fullMonth: true })}</b>.</span> {/* calc_p2EarliestServiceDate */}
        </span>
      </p>
      <p className="ric__rule">
        <img className="w1-step-three__rule__icon" src={appliedRuleIcon} alt='' />
        <span>
          <b>Applied Rule</b>: The phase 2 additional rent increase must be imposed within 12 months of the earliest allowed date after the phase 1 rent increase.
          <span className="w1-step-three__rule--error">&nbsp;The last allowed date for this rent increase to be effective is&nbsp;<b>{formatter.toDateDisplay(calc_p2MaxRentIncreaseDate, { fullMonth: true })}</b>. If you do not impose the second additional rent increase by this date, you will not be allowed to include the eligible amount for phase 2 in any future rent increases.</span>
        </span>
      </p>
      { calc_p2IsServiceTimeAvailable && !isRentIncreaseAfterPhase2 ?
        <CustomDateInput
          name='phase2RentIncreaseDate'
          disabled={stepTwoSubmitted}
          value={phase2RentIncreaseDate}
          errors={errors.phase2RentIncreaseDate}
          cssClass='decision-questions__decisionDate'
          minDate={moment(calc_p2MinRentIncreaseDate).toDate()}
          maxDate={moment(calc_p2MaxRentIncreaseDate).toDate()}
          openToDate={moment(calc_p2MinRentIncreaseDate).toDate()}
          label={`
            On what date between ${formatter.toDateDisplay(calc_p2MinRentIncreaseDate, { fullMonth: true })} and ${formatter.toDateDisplay(calc_p2MaxRentIncreaseDate, { fullMonth: true })} do you plan to impose your second (phase 2) additional rent increase? Note: The earliest date you can select may be restricted, 
            as the tenant must be served notice of this rent increase a minimum of 3 full months in advance of the intended effective date, plus 1 day.</span>
          `}
          handleChange={handleDateChange}
        /> 
      : null }

      { calc_p2IsServiceTimeAvailable && !isRentIncreaseAfterPhase2 ? <div className="ric__buttons hide-print">
        <Button variant="success" onClick={() => submitStepTwo()} disabled={stepTwoSubmitted}>Continue</Button>
        { stepTwoSubmitted ? <span className="w1-step-one__modify" onClick={() => modifyClicked()}><img src={restartIcon} alt=""/> Modify</span> : null }
      </div> : null }
    </div>
  )
}

export default RICalcStepTwo;